import { gql } from '@apollo/client';
const UPDATE_GLOBAL_EXCHANGE_RATE = gql `
  mutation UpdateGlobalExchangeRate($globalExchangeRateId: ID!, $newRate: Float!) {
    updateGlobalExchangeRate(globalExchangeRateId: $globalExchangeRateId, newRate: $newRate) {
      exchangeRate {
        id
      }
    }
  }
`;
export default UPDATE_GLOBAL_EXCHANGE_RATE;
